<template>
    <div class="table-attribute-picker">
        <div class="filter-menu">
            <SupsisButton v-if="this.selectedMenu.length" ghost small @click="prev">
                <span class="material-icons"> chevron_left </span>
            </SupsisButton>
            <div class="breadcrumb-item" v-for="menu in this.selectedMenu" :key="menu">
                <span> {{ findAttributeByValue(menu).label }} ✦ </span>
            </div>
        </div>
        <div class="attribute-list">
            <div class="attr-select">
                <div
                    class="picker-item"
                    v-for="attr in filterAttributes()"
                    @click="() => select(attr.value)"
                    :key="attr.value"
                >
                    <!-- Attribute bilgilerini göster -->
                    <span class="name">{{ attr.label }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import TableModuleAttributeFactory from "../../../../Automation/utils/modules/table.module";
import SupsisButton from "../../../../Settings/components/SupsisButton.vue";
import flatDiagram from "../../../utils/flatDiagram";

export default {
    name: "TableAttributePicker",
    components: {
        SupsisButton,
    },
    props: {
        onPicked: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            searchText: "",
            attributes: [],
            selectedMenu: [],
        };
    },
    computed: {
        ...mapGetters({
            board: "CB/board",
        }),
    },
    methods: {
        listTableBlockAttributes() {
            const storyId = this.$route.params.id;
            const board = this.board(storyId);
            const factory = new TableModuleAttributeFactory(this);
            const flatted = flatDiagram(board.diagram);
            this.tableBlocks = flatted.filter((block) => block.type.startsWith("TABLE_"));
            console.log("listAttributesForChatbot before", {
                flatted,
                board,
                tableBlocks: flatted.filter((block) => block.type.startsWith("table_")),
            });
            return factory.listAttributesForChatbot(this.tableBlocks);
        },
        loadAttributes() {
            this.attributes = this.listTableBlockAttributes();
            console.log("Yüklenen attribute'ler:", this.attributes);
        },
        filterAttributes() {
            const parentAttribute = this.getParentAttribute();
            let attrs = parentAttribute ? parentAttribute.subAttributes : this.attributes;
            return attrs.filter((attr) => {
                if (this.searchText) {
                    return (attr.label || "").toLowerCase().includes(this.searchText.toLowerCase());
                }
                return true;
            });
        },
        getParentAttribute() {
            const attributes = this.getFlatAttributes();
            const parent = this.selectedMenu[this.selectedMenu.length - 1];
            return attributes.find((x) => x.value === parent);
        },
        getFlatAttributes() {
            const flat = (attr) => {
                if (attr.subAttributes) {
                    return [attr, ...attr.subAttributes.flatMap(flat)];
                }
                return [attr];
            };
            return this.attributes.flatMap(flat);
        },
        select(value) {
            const attributes = this.getFlatAttributes();
            const attr = attributes.find((x) => x.value === value);
            if (Array.isArray(attr.subAttributes) && attr.subAttributes.length) {
                this.selectedMenu.push(value);
            } else {
                this.onPicked(value);
            }
        },
        prev() {
            this.selectedMenu.pop();
        },
        findAttributeByValue(value) {
            const attributes = this.getFlatAttributes();
            return attributes.find((x) => x.value === value);
        },
    },
    created() {
        this.loadAttributes();
    },
};
</script>

<style lang="scss" scoped>
.table-attribute-picker {
    background: #fff;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    max-height: 600px;
    min-height: 200px;
    user-select: none;
    width: 100%;
    padding: 5px;

    .search-panel {
        align-items: center;
        border-bottom: 1px solid #e8eef3;
        display: flex;
        flex-shrink: 0;
        position: relative;
        width: 100%;

        input {
            background: transparent;
            border: 0;
            font-size: 16px;
            height: 40px;
            line-height: 20px;
            padding-left: 45px;
            padding-right: 15px;
            width: 100%;
        }

        span {
            color: #9ba6b3;
            font-size: 18px;
            left: 15px;
            pointer-events: none;
            position: absolute;
            transition: color 0.3s;
        }
    }

    .filter-menu {
        display: flex;
        align-items: center;
        gap: 3px;

        .supsis-button {
            border: none !important;
            font-size: 13px;
            height: 25px;
        }

        .breadcrumb-item {
            display: flex;
        }
    }

    .attribute-list {
        flex-grow: 1;
        overflow-x: hidden;
        overflow-y: auto;
        padding: 5px;
        margin: 0px 5px 0px 5px;
        gap: 10px;

        .attr-select {
            margin-bottom: 10px;
        }
    }

    .picker-item {
        align-items: center;
        cursor: pointer;
        display: flex;
        height: 32px;
        padding: 0 5px;
        transition: background-color 0.2s, opacity 0.2s;

        &:hover {
            background-color: #f0f4f7;
        }

        .name {
            color: #22272d;
            font-size: 16px;
            font-weight: 400;
            line-height: 20px;
            margin-right: 30px;
        }
    }
}
</style>
